import styles from './index.module.css'
import { useEffect, useRef, useState } from 'react'
import { VmsModalPopup } from '@/components/vms-components/ModalPopup/index'
import { VmsButton } from '@/components/vms-components/button/index'
import { VmsInputText } from '@/components/vms-components/InputText/index'
import { VmsModalOverlay } from '../../../vms-components/ModalOverlay/index'
import { useRouter } from 'next/router'

export default function Index(props) {
  const {
    setOpenShare,
    openShare,
    isMobile,
    displayCopyInput = true,
    partUrl,
    shareId
  } = props

  const router = useRouter()
  const [link, setLink] = useState('')

  console.log("partUrl", partUrl)

  useEffect(() => {
    if (!router.isReady) return
    const origin = window.location.origin
    const fullUrl = `${origin}/${partUrl}`
    setLink(fullUrl)
  }, [router.isReady, shareId])

  const shareOptions = [
    {
      id: 'whatsapp',
      icon: 'images/te_whatsapp.png',
      title: 'WhatsApp',
      status: true,
      link: {
        mobile: `whatsapp://send?text=${encodeURIComponent(link)}`,
        desktop: `https://web.whatsapp.com/send?text=${encodeURIComponent(link)}`,
      },
    },
    {
      id: 'facebook',
      icon: 'images/te_facebook.png',
      title: 'Facebook',
      status: true,
      link: {
        all: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`,
      },
    },

    {
      id: 'instagram',
      icon: 'images/te_instagram.png',
      title: 'Instagram',
      status: true,
      link: {
        all: `https://www.instagram.com/`, // no direct link sharing
      },
    },
    {
      id: 'gmail',
      icon: 'images/te_gmail.png',
      title: 'Gmail',
      status: true,
      link: {
        all: `mailto:?subject=Check this out&body=${encodeURIComponent(link)}`,
      },
    },
    {
      id: 'copylink',
      icon: 'images/copy_link.svg',
      title: 'Copy Link',
      status: true,
    },
  ]

  const inputRef = useRef(null)

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(link)
    } catch (err) {
      if (inputRef.current) {
        inputRef.current.select()
        document.execCommand('copy')
      }
    }
  }


  const handleClose = () => setOpenShare(false)

  const ModalComponent = isMobile ? VmsModalOverlay : VmsModalPopup

  const handleShare = (option) => {
    const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    const url = option?.link?.all || (isMobileDevice ? option?.link?.mobile : option?.link?.desktop)
    if (url) {
      window.open(url, '_blank')
      setOpenShare(false)
    }
  }

  const modalProps = isMobile
    ? {
      isOpen: openShare,
      onModalClose: handleClose,
      additionalClassName: styles.modalPopup,
    }
    : {
      isOpen: openShare,
      onRequestClose: handleClose,
      additionalClassName: styles.modalPopup,
    }

  const modalHeader = () => (
    <div className={styles.modal_header}>
      <div className={styles.modal_title}>{isMobile ? 'Share' : 'Share On'}</div>
      <button className={styles.modal_close_btn} onClick={handleClose}>
        <img src="images/te_btn_blue_Close.svg" alt="Close" />
      </button>
    </div>
  )

  return (
    <div className={styles.shareContainer}>
      <ModalComponent {...modalProps}>
        {modalHeader()}

        <div className={styles.modalContent}>
          <div
            className={
              isMobile
                ? styles.socialButtonsContainer
                : displayCopyInput
                  ? styles.inputContainer
                  : ''
            }
          >
            {isMobile ? (
              <div className={styles.carouselContainer}>
                <div className={styles.carousel}>
                  {shareOptions
                    .filter((opt) => opt.status)
                    .map((opt) => (
                      <button key={opt.id} className={styles.socialButton} title={opt.title} onClick={() => opt.title == "Copy Link" ? handleCopyLink() : handleShare(opt)}>
                        <img src={opt.icon} alt={opt.title} width={40} height={40} />
                        <p>{opt.title}</p>
                      </button>
                    ))}
                </div>
              </div>
            ) : (
              <>
                {displayCopyInput && (
                  <>
                    <VmsInputText
                      type="text"
                      value={link}
                      readOnly
                      inputRef={inputRef}
                      className={styles.linkInput}
                    />
                    <VmsButton size="small" onClick={handleCopyLink}>
                      Copy Link
                    </VmsButton>
                  </>
                )}
              </>
            )}
          </div>

          {isMobile ? (
            <>
              <div className={styles.divider} />
              <div className={styles.mobileActions}>
                <VmsButton size="small" onClick={handleCopyLink} className={styles.actionBtn}>
                  <span className={styles.mob_action_icon}>
                    <img src="images/te_copylink.png" alt="Copy" />
                  </span>
                  Copy link
                </VmsButton>
                <VmsButton size="small" className={styles.actionBtn}>
                  <span className={styles.mob_action_icon}>
                    <img src="images/share_exp_icon.svg" alt="share" />
                  </span>
                  Quick Share
                </VmsButton>
              </div>
            </>
          ) : (
            <>
              {displayCopyInput && <div className={styles.shareOnText}>Or share on</div>}
              <div className={styles.socialButtonsContainer}>
                {shareOptions
                  .filter((opt) => opt.status)
                  .map((opt) => (
                    <button key={opt.id} className={styles.socialButton} title={opt.title} onClick={() => opt.title == "Copy Link" ? handleCopyLink() : handleShare(opt)}>
                      <img src={opt.icon} alt={opt.title} width={40} height={40} />
                    </button>
                  ))}
              </div>
            </>
          )}
        </div>
      </ModalComponent>
    </div>
  )
}
